
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorite/[urlname]",
      function () {
        return require("private-next-pages/favorite/[urlname].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/favorite/[urlname]"])
      });
    }
  